module.exports = __webpack_public_path__ + "img/dashboard-header.3f89d3fb.jpg";